module.exports = __webpack_public_path__ + "img/photo-8.f35935ee.webp";